// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_fa37b0d","eachWayWrapper":"_9901101","rowOne":"_36b71ad","rightColumn":"_96ecbf6","heading":"_4705295"};